// extracted by mini-css-extract-plugin
export default {"products":"Ct-z","card":"Dt-z","oosMessaging":"Et-z"};